module.exports = __webpack_public_path__ + "img/mobile-neck-16_156x18.bdf7d4ba.png";